export default __webpack_public_path__ + "static/media/PRESTIGIO_IMPERO_LUCIDO_120X278_003_265.243843f3.jpg";